import type { CmsSaveState, CmsSaveStateDetail } from "../types";

const LABELS: Record<CmsSaveState, string> = {
    idle: "변경 없음",
    dirty: "저장 필요",
    saving: "저장 중...",
    saved: "저장됨",
    failed: "저장 실패",
    offline: "오프라인",
};

export class CmsSaveStatusBar {
    readonly #target: HTMLElement | null;
    #state: CmsSaveState = navigator.onLine ? "idle" : "offline";

    constructor(private readonly root: HTMLElement) {
        this.#target = root.querySelector<HTMLElement>("[data-cms-save-status]");
    }

    init(): void {
        this.#render();
        this.root.addEventListener("cms:save-state", (event) => {
            const detail = (event as CustomEvent<CmsSaveStateDetail>).detail;
            this.set(detail.state, detail.message);
        });
        window.addEventListener("online", () => this.set("idle"));
        window.addEventListener("offline", () => this.set("offline", "네트워크 연결을 확인하세요."));
    }

    set(state: CmsSaveState, message?: string): void {
        this.#state = state;
        this.#render(message);
    }

    #render(message?: string): void {
        if (!this.#target) return;
        this.#target.dataset.cmsSaveState = this.#state;
        this.#target.textContent = message ?? LABELS[this.#state];
    }
}
